import { Stack } from "@mui/material";

export default function WushCard({ onClick, disabled, border, bgcolor, sx, children, ...props }) {
  return (
    <Stack
      onClick={!disabled ? onClick : console.log}
      sx={{
        bgcolor: (disabled && "lightgrey") || bgcolor,
        border: border || "1px solid transparent",
        borderRadius: "10px",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        width: "100%",
        '&:hover': {
          cursor: !disabled && onClick && "pointer",
          borderColor: !disabled && !border && "rgba(0, 0, 0, 0.1)"
        },
        transition: "all 0.2s",
        position: "relative",
        ...sx
      }}
      {...props}
    >
      {children}
    </Stack>
  );
}